var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import RangeModel from "./RangeModel";
var RangeDoubleModel = /** @class */ (function (_super) {
    __extends(RangeDoubleModel, _super);
    function RangeDoubleModel(min, max, isSm, step, prefix, suffix, value2) {
        var _this = _super.call(this, min, max, isSm, step, prefix, suffix) || this;
        _this._value2 = 0;
        _this._value2 = value2 !== null && value2 !== void 0 ? value2 : 0;
        return _this;
    }
    Object.defineProperty(RangeDoubleModel.prototype, "value2", {
        get: function () {
            return this._value2;
        },
        set: function (value) {
            this._value2 = value;
        },
        enumerable: false,
        configurable: true
    });
    RangeDoubleModel.prototype.getInnerPadding = function () {
        return (this._isSm ? 16 : 24) * 2;
    };
    RangeDoubleModel.prototype.getRatio = function () {
        return this.calculRatio((this._value + this._value2) * 0.5);
    };
    RangeDoubleModel.prototype.getClassName = function (customClassName) {
        var rangeClass = "fr-range fr-range--double ";
        if (this._step) {
            rangeClass += "fr-range--step ";
        }
        if (this._isSm) {
            rangeClass += "fr-range--sm ";
        }
        if (customClassName) {
            rangeClass += customClassName;
        }
        return rangeClass;
    };
    RangeDoubleModel.prototype.getProgressStyle = function () {
        var innerWidth = this._width - this.getInnerPadding();
        var ratio1 = this.calculRatio(this._value);
        var ratio2 = this.calculRatio(this._value2);
        return {
            "--progress-left": "".concat((innerWidth * ratio1 + this.getInnerPadding() * 0.25).toFixed(2), "px"),
            "--progress-right": "".concat((innerWidth * ratio2 + this.getInnerPadding() * 0.75).toFixed(2), "px"),
        };
    };
    RangeDoubleModel.prototype.getStepStyle = function () {
        if (this._step !== undefined) {
            var steps = this.getRangeWidth() / this._step;
            var stepWidth = this.getInnerWidth() / steps;
            if (stepWidth <= 0) {
                return {};
            }
            if (stepWidth < 4)
                stepWidth *= Math.ceil(4 / stepWidth);
            return {
                "--step-width": "".concat(stepWidth, "px"),
            };
        }
        return {};
    };
    RangeDoubleModel.prototype.getRangeString = function () {
        return "".concat(this.formatString(this._value), "-").concat(this.formatString(this._value2));
    };
    return RangeDoubleModel;
}(RangeModel));
export default RangeDoubleModel;
